// Video Carousel
const videos_swiper = new Swiper('.videos__list_slider', {
    centeredSlides: true,
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    freeMode: false,
    direction: "horizontal",
    mousewheel: { 
      forceToAxis: true 
    },
    keyboard: { 
      enabled: true 
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
});

// Meet our team Carousel
const meet_swiper = new Swiper('.meet-our-team_slider', {
    centeredSlides: true,
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    freeMode: false,
    direction: "horizontal",
    mousewheel: {
      forceToAxis: true 
    },
    keyboard: {
      enabled: true 
    }
});

// Video Play/Pause
document.addEventListener('DOMContentLoaded', () => {
  const videoWraps = document.querySelectorAll('.video__wrap');

  const resetVideoState = (wrap) => {
    const video = wrap.querySelector('video');
    const iconMute = wrap.querySelector('.icon_mute');
    const iconUnmute = wrap.querySelector('.icon_unmute');
    const iconPlay = wrap.querySelector('.icon_play');
    const iconPause = wrap.querySelector('.icon_pause');

    video.pause();
    video.currentTime = 0;
    video.load(); // restore poster

    video.muted = true;
    iconMute.style.display = 'block';
    iconUnmute.style.display = 'none';
    iconPlay.style.display = 'block';
    iconPause.style.display = 'none';
  };

  const toggleIcons = (video, muteIcon, unmuteIcon, playIcon, pauseIcon) => {
    muteIcon.style.display = video.muted ? 'block' : 'none';
    unmuteIcon.style.display = video.muted ? 'none' : 'block';
    playIcon.style.display = video.paused ? 'block' : 'none';
    pauseIcon.style.display = video.paused ? 'none' : 'block';
  };

  videoWraps.forEach(wrap => {
    const video = wrap.querySelector('video');
    const muteBtn = wrap.querySelector('.mute__btn');
    const playBtn = wrap.querySelector('.play__btn');
    const iconMute = wrap.querySelector('.icon_mute');
    const iconUnmute = wrap.querySelector('.icon_unmute');
    const iconPlay = wrap.querySelector('.icon_play');
    const iconPause = wrap.querySelector('.icon_pause');

    // ✅ Initial state
    resetVideoState(wrap);

    // ✅ Mute/Unmute
    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      toggleIcons(video, iconMute, iconUnmute, iconPlay, iconPause);
    });

    // ✅ Play / Pause + Reset Other Videos
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        videoWraps.forEach(other => {
          if (other !== wrap) resetVideoState(other);
        });

        video.play();
      } else {
        video.pause();
      }

      toggleIcons(video, iconMute, iconUnmute, iconPlay, iconPause);
    });

    // ✅ Reset after video ends
    video.addEventListener('ended', () => resetVideoState(wrap));
  });
});

// Collapsible Accordion
$(".accordion").on("click", ".accordion__title", function() {
    let $title = $(this);
    let $card = $title.closest(".accordion__card"); // get parent card

    // toggle active on clicked title + parent card
    $title.toggleClass("active");
    $card.toggleClass("active");

    // toggle content
    $title.next().slideToggle();

    // close other accordions
    $(".accordion__content").not($title.next()).slideUp(300);
    $(".accordion__title").not($title).removeClass("active");
    $(".accordion__card").not($card).removeClass("active");
});
  
// Collapsible popup
document.addEventListener('DOMContentLoaded', () => {
  const popupCards = document.querySelectorAll('.popup__card');
  const body = document.body;
  const closeBtns = document.querySelectorAll('.close_popup');

  function closeAllPopups() {
    popupCards.forEach(c => {
      const innerContent = c.querySelector('.popup__card_content');
      innerContent.classList.remove('active');
    });
    body.classList.remove('open_popup');
  }

  popupCards.forEach(card => {
    const title = card.querySelector('.popup__card_title');
    const content = card.querySelector('.popup__card_content');

    title.addEventListener('click', () => {
      const isOpen = content.classList.contains('active');

      closeAllPopups();

      if (!isOpen) {
        content.classList.add('active');
        body.classList.add('open_popup');
      }
    });
  });

  // ✅ Close on clicking .close_popup
  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      closeAllPopups();
    });
  });
});

// News Letter popup
$('.close_newsletter').click(function() {
    $('.sticky-signup').addClass('hide');
});
$('.mobile_menu__close').click(function() {
    $('.header__icon--menu').trigger('click');
});

// Client Archives Filter
document.addEventListener("DOMContentLoaded", function() {
  const filterItems = document.querySelectorAll(".archives_filter_item");
  const buttons = document.querySelectorAll(".archives_filter_item button");
  const cards = document.querySelectorAll(".popup__card");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const selectedTag = button.getAttribute("data-tag");

      // Remove active from all filter items
      filterItems.forEach(item => item.classList.remove("active"));

      // Add active to parent .archives_filter_item
      button.closest(".archives_filter_item").classList.add("active");

      // Show/hide cards
      cards.forEach(card => {
        const cardTag = card.getAttribute("data-tag");
        if (cardTag === selectedTag || selectedTag === "All") {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
});

// Hero video mute unmute
document.addEventListener("DOMContentLoaded", function() {
  const soundIcon = document.querySelector('.sound_icon');
  const muteIcon = soundIcon?.querySelector('.icon__mute');
  const unmuteIcon = soundIcon?.querySelector('.icon__unmute');
  const videos = document.querySelectorAll('.hero__video');

  if (!soundIcon || videos.length === 0) return;

  soundIcon.addEventListener('click', function() {
    let isMuted = videos[0].muted; // Assume all videos share the same state

    videos.forEach(video => {
      video.muted = !isMuted;
    });

    if (isMuted) {
      // 🔊 Now unmuted
      muteIcon.style.display = 'none';
      unmuteIcon.style.display = 'block';
    } else {
      // 🔇 Now muted
      muteIcon.style.display = 'block';
      unmuteIcon.style.display = 'none';
    }
  });
});


$('.marquee').marquee({
  //If you wish to always animate using jQuery
  allowCss3Support: true
  , //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
  css3easing: 'linear'
  , //requires jQuery easing plugin. Default is 'linear'
  easing: 'linear'
  , //pause time before the next animation turn in milliseconds
  delayBeforeStart: 1000
  , //'left', 'right', 'up' or 'down'
  direction: 'left'
  , //true or false - should the marquee be duplicated to show an effect of continues flow
  duplicated: true
  , //speed in milliseconds of the marquee in milliseconds
  duration: 20000
  , //gap in pixels between the tickers
  gap: 0
  , //on cycle pause the marquee
  pauseOnCycle: false
  , //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
  pauseOnHover: false
  , //the marquee is visible initially positioned next to the border towards it will be moving
  startVisible: true
});